var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystals1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 76,
    viewBox: "0 0 81 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5533 8.18766L65.4311 6.35125C64.0333 4.87412 62.0965 4.03721 60.072 4.03533L20.8912 4C18.8665 3.99807 16.9312 4.83151 15.5362 6.30623L15.5378 8.14268L25.6743 24.9196L56.9415 24.9477L65.5533 8.18766Z",
    fill: "#C3DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8912 4C18.8665 3.99807 16.9312 4.83151 15.5362 6.30623L15.5378 8.14268L20.6331 16.5761L29.3871 4.0078L20.8912 4Z",
    fill: "#A4CCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4815 4.01765L26.4193 24.9201L27.2978 25.7819L53.1616 25.8052L54.5805 24.9456L40.4815 4.01765Z",
    fill: "#DBEAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5362 6.30623L1.48285 21.158C0.529679 22.1654 -0.00125029 23.5038 2.21101e-06 24.8962L0.931561 25.7578L24.9526 25.7795L26.4193 24.9201L15.5362 6.30623Z",
    fill: "#DBEAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8282 24.9098L21.1263 15.8675L15.5362 6.30623L1.48285 21.158C0.529679 22.1654 -0.00125029 23.5038 2.21101e-06 24.8962L0.931561 25.7578L15.2728 25.771L14.8282 24.9098Z",
    fill: "#C3DDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24.9692C80.9987 23.5768 80.4654 22.2376 79.5104 21.2284L65.4311 6.35125L54.5805 24.9456L55.6616 25.8072L80.2907 25.8294L81 24.9692Z",
    fill: "#DBEAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21101e-06 24.8962C0.00135429 26.4589 0.556187 27.9709 1.56483 29.1607L34.7657 68.3144C36.2092 70.0166 38.3195 70.9981 40.5404 71C42.7614 71.0019 44.8701 70.0245 46.3105 68.3248L79.4421 29.2307C80.4489 28.0429 81.0015 26.5322 81 24.9692L2.21101e-06 24.8962Z",
    fill: "#A4CCFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8282 24.9098L2.21101e-06 24.8962C0.00135429 26.4589 0.556187 27.9709 1.56483 29.1607L34.7657 68.3144C35.7462 69.4705 37.0344 70.2933 38.456 70.7035L14.8282 24.9098Z",
    fill: "#8BB3EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5404 71C41.2528 71.0007 41.9537 70.9 42.6247 70.7074L54.5805 24.9456L26.4193 24.9201L38.456 70.7035C39.1272 70.8969 39.8277 70.9992 40.5404 71Z",
    fill: "#C3DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystals1X);
export default __webpack_public_path__ + "static/media/crystals1x.f981cfad7d6d88485bfbd14be494ce80.svg";
export { ForwardRef as ReactComponent };